/**
 * https://developer.openstack.org/api-ref/compute/#flavors
 */

import { OpenStackApiHelper } from 'utils/OpenStackApiHelper/OpenStackApiHelper';

const LIST_URL = '/infra/compute/v2.1/flavors/detail';

export const FlavorApi = {
    async loadList() {
        const { flavors } = await OpenStackApiHelper.openstackRpcCall({
            url: LIST_URL,
        });

        return flavors;
    },
};
